module.exports = __webpack_public_path__ + "static/icons/icon-chevron-circle-right--white-7d6d2b2b85a6f0ae23a09ce5a242e083.svg";